import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'

import css from './two-column-responsive-page-container.scss'
import { SectionHeading } from '../headings'

const PageContainer = ({
  children,
  title,
  mobileBack,
  mobileHideMenu,
  mobileHideContent,
}) => {
  return (
    <div style={{ minHeight: 600 }} className="mbxl">
      <Row>
        <Col
          sm={3}
          className={classNames(css['nav-container'], {
            'hidden-xs': mobileHideMenu,
          })}
        >
          <SectionHeading
            className={classNames(css['page-header'], 'mvl', {
              'hidden-xs': mobileHideMenu,
            })}
          >
            {title}
          </SectionHeading>
          {children[0]}
        </Col>
        <Col
          sm={9}
          className={classNames(css['main-container'], {
            'hidden-xs': mobileHideContent,
          })}
        >
          <div className="mvl visible-xs h6">{mobileBack}</div>
          {children[1]}
        </Col>
      </Row>
    </div>
  )
}

export default PageContainer
